import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_COMPONENT_TEXT_SIZE } from './slideConstants';

export function ComparisonFrameworkSlide({ slide }: SlideProps) {
  const dataContent = slide.data?.content ?? slide.data?.items ?? slide.data?.data ?? slide.data;
  
  let content = '';
  if (dataContent) {
    if (typeof dataContent === 'string') {
      content = dataContent;
    } else if (Array.isArray(dataContent)) {
      content = dataContent.map((item: any, i: number) => `${i + 1}. ${typeof item === 'string' ? item : JSON.stringify(item)}`).join('\n\n');
    } else if (typeof dataContent === 'object') {
      content = Object.entries(dataContent).map(([k, v]) => `${k}: ${String(v)}`).join('\n\n');
    }
  }

  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center overflow-y-auto max-h-full">
      <div className="p-4 md:p-6 rounded-xl bg-white/5 border border-white/10 backdrop-blur-md shadow-xl w-full text-left">
        <Text size={SLIDE_COMPONENT_TEXT_SIZE} className="text-white/90 leading-relaxed whitespace-pre-wrap font-normal italic text-left text-sm md:text-md">
          {`&quot;${content}&quot;`}
        </Text>
      </div>
    </div>
  );
}
